import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import LeadFormButton from '../../../components/LeadFormButton';

const ArtisanProfiles = () => {
  const [activeArtisan, setActiveArtisan] = useState(0);

  const artisans = [
    {
      id: 1,
      name: "Paulo Henrique Silva",
      role: "Fundador & Mestre Marceneiro",
      experience: "25 anos",
      specialty: "Móveis Clássicos & Design Contemporâneo",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      bio: `Fundador da PH Móveis, Paulo Henrique iniciou sua jornada artesanal aos 18 anos, aprendendo técnicas tradicionais com mestres marceneiros. Sua paixão pela madeira e pelo design único o levou a criar peças que são verdadeiras obras de arte funcionais.\n\nEspecialista em madeiras nobres brasileiras, Paulo desenvolveu técnicas próprias de acabamento que realçam a beleza natural de cada peça. Seu trabalho já foi reconhecido em diversas exposições nacionais de design.`,
      achievements: [
        "Prêmio Design Brasil 2008, 2015, 2020",
        "Exposição no Museu da Casa Brasileira",
        "Certificação em Sustentabilidade Florestal",
        "Mentor de 15+ novos artesãos"
      ],
      skills: ["Marcenaria Clássica", "Design Contemporâneo", "Restauração", "Sustentabilidade"],
      quote: "Cada peça de madeira tem sua própria personalidade. Meu trabalho é revelar sua beleza única."
    },
    {
      id: 2,
      name: "Maria Santos",
      role: "Mestra em Acabamentos",
      experience: "18 anos",
      specialty: "Técnicas de Pátina & Envelhecimento",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b786?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      bio: `Maria é reconhecida como uma das maiores especialistas em técnicas de acabamento artesanal do Brasil. Sua expertise em pátinas, envelhecimento e texturas especiais transforma cada móvel em uma peça única com história própria.\n\nFormada em Artes Plásticas, Maria trouxe para a marcenaria técnicas inovadoras que combinam tradição e modernidade. Seus acabamentos são solicitados por designers de interiores de todo o país.`,
      achievements: [
        "Especialização em Técnicas Europeias",
        "Desenvolvimento de 12 técnicas próprias",
        "Consultoria para museus nacionais",
        "Formação de 8 especialistas"
      ],
      skills: ["Pátinas Artísticas", "Envelhecimento", "Texturas Especiais", "Restauração Histórica"],
      quote: "O acabamento é a alma do móvel. É onde a madeira ganha vida e personalidade."
    },
    {
      id: 3,
      name: "João Carlos Oliveira",
      role: "Especialista em Entalhes",
      experience: "22 anos",
      specialty: "Entalhes Decorativos & Relevos",
      image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      bio: `João Carlos é um verdadeiro artista da madeira, especializado em entalhes decorativos que transformam móveis simples em obras de arte. Sua precisão e criatividade são reconhecidas em todo o setor moveleiro brasileiro.\n\nHerdeiro de uma família de entalhadores, João aprendeu as técnicas tradicionais desde criança e as aperfeiçoou com estudos em design contemporâneo. Cada entalhe seu conta uma história única.`,
      achievements: [
        "Tradição familiar de 3 gerações",
        "Especialização em Motivos Brasileiros",
        "Participação em 20+ exposições",
        "Técnicas registradas no IPHAN"
      ],
      skills: ["Entalhes Clássicos", "Relevos Modernos", "Motivos Brasileiros", "Esculturas em Madeira"],
      quote: "Cada entalhe é uma conversa entre o artesão e a madeira. Preciso ouvir o que ela quer me dizer."
    },
    {
      id: 4,
      name: "Ana Paula Costa",
      role: "Designer & Planejadora",
      experience: "12 anos",
      specialty: "Design Funcional & Ergonomia",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      bio: `Ana Paula combina formação em Design de Interiores com paixão pela marcenaria artesanal. Ela é responsável por traduzir os sonhos dos clientes em projetos funcionais e esteticamente perfeitos.\n\nEspecialista em ergonomia e funcionalidade, Ana garante que cada peça não seja apenas bela, mas também perfeitamente adequada ao uso e ao espaço do cliente. Sua abordagem humanizada do design faz toda a diferença.`,
      achievements: [
        "Formação em Design de Interiores",
        "Especialização em Ergonomia",
        "200+ projetos personalizados",
        "Consultoria em sustentabilidade"
      ],
      skills: ["Design Funcional", "Ergonomia", "Planejamento 3D", "Consultoria Personalizada"],
      quote: "Design não é apenas sobre beleza, é sobre criar móveis que melhorem a vida das pessoas."
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 bg-secondary/10 text-secondary px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Icon name="Users" size={16} />
            <span>Nossa Equipe</span>
          </div>
          <h2 className="font-playfair text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-6">
            Mestres Artesãos
            <span className="block text-secondary">da PH Móveis</span>
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Conheça os talentosos profissionais que transformam madeira em arte, 
            cada um com sua especialidade única e anos de experiência dedicados à excelência.
          </p>
        </div>

        {/* Artisan Selection */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {artisans?.map((artisan, index) => (
            <button
              key={artisan?.id}
              onClick={() => setActiveArtisan(index)}
              className={`flex items-center space-x-3 px-6 py-3 rounded-full transition-all duration-300 ${
                activeArtisan === index
                  ? 'bg-primary text-primary-foreground shadow-forest'
                  : 'bg-muted text-text-primary hover:bg-primary/10 hover:text-primary'
              }`}
            >
              <div className="w-8 h-8 rounded-full overflow-hidden">
                <Image
                  src={artisans?.[index]?.image}
                  alt={artisans?.[index]?.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="font-medium">{artisan?.name}</span>
            </button>
          ))}
        </div>

        {/* Active Artisan Profile */}
        <div className="bg-gradient-to-br from-muted/50 to-white rounded-3xl p-8 lg:p-12 shadow-premium border border-border">
          <div className="grid lg:grid-cols-2 gap-12 items-start">
            {/* Artisan Image & Info */}
            <div className="space-y-6">
              <div className="relative">
                <div className="relative overflow-hidden rounded-2xl shadow-premium">
                  <Image
                    src={artisans?.[activeArtisan]?.image}
                    alt={artisans?.[activeArtisan]?.name}
                    className="w-full h-96 object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-primary/20 to-transparent"></div>
                </div>
                
                {/* Experience Badge */}
                <div className="absolute -bottom-4 left-6 bg-accent text-accent-foreground px-4 py-2 rounded-full shadow-premium">
                  <div className="text-sm font-bold">{artisans?.[activeArtisan]?.experience}</div>
                </div>
              </div>

              {/* Skills */}
              <div>
                <h4 className="font-playfair text-lg font-bold text-primary mb-3">Especialidades</h4>
                <div className="flex flex-wrap gap-2">
                  {artisans?.[activeArtisan]?.skills?.map((skill, index) => (
                    <span
                      key={index}
                      className="bg-primary/10 text-primary px-3 py-1 rounded-full text-sm font-medium"
                    >
                      {skill}
                    </span>
                  ))}
                </div>
              </div>
            </div>

            {/* Artisan Details */}
            <div className="space-y-6">
              <div>
                <h3 className="font-playfair text-3xl font-bold text-primary mb-2">
                  {artisans?.[activeArtisan]?.name}
                </h3>
                <p className="text-lg text-secondary font-medium mb-1">
                  {artisans?.[activeArtisan]?.role}
                </p>
                <p className="text-text-secondary">
                  {artisans?.[activeArtisan]?.specialty}
                </p>
              </div>

              {/* Quote */}
              <div className="bg-white rounded-xl p-6 border-l-4 border-accent shadow-sm">
                <Icon name="Quote" size={24} color="var(--color-accent)" className="mb-3" />
                <p className="text-text-primary italic leading-relaxed">
                  "{artisans?.[activeArtisan]?.quote}"
                </p>
              </div>

              {/* Biography */}
              <div>
                <h4 className="font-playfair text-lg font-bold text-primary mb-3">Biografia</h4>
                <div className="text-text-secondary leading-relaxed space-y-4">
                  {artisans?.[activeArtisan]?.bio?.split('\n\n')?.map((paragraph, index) => (
                    <p key={index}>{paragraph}</p>
                  ))}
                </div>
              </div>

              {/* Achievements */}
              <div>
                <h4 className="font-playfair text-lg font-bold text-primary mb-3">Conquistas</h4>
                <ul className="space-y-2">
                  {artisans?.[activeArtisan]?.achievements?.map((achievement, index) => (
                    <li key={index} className="flex items-start space-x-3">
                      <Icon name="Award" size={16} color="var(--color-accent)" className="mt-1 flex-shrink-0" />
                      <span className="text-text-secondary">{achievement}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* CTA */}
              <div className="pt-4">
                <LeadFormButton
                  variant="outline"
                  iconName="MessageCircle"
                  iconPosition="left"
                  className="border-primary text-primary hover:bg-primary hover:text-primary-foreground"
                >
                  Conversar com {artisans?.[activeArtisan]?.name?.split(' ')?.[0]}
                </LeadFormButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ArtisanProfiles;